import { format } from 'date-fns';
import { isSSR } from './ssr';
export function ensureDate(value) {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return date;
}
export function formatDateISO(value) {
    const date = ensureDate(value);
    return date.toISOString();
}
const DEFAULT_DATE_OPTIONS = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
};
export function formatDate(value, options = DEFAULT_DATE_OPTIONS) {
    const date = ensureDate(value);
    if (isSSR()) {
        return format(date, options.dateStyle === 'short' ? 'dd/MM/yyyy' : 'MMMM dd, yyyy');
    }
    return new Intl.DateTimeFormat(undefined, options).format(date);
}
const DEFAULT_NUMBER_OPTIONS = {};
export function formatNumber(value, options = DEFAULT_NUMBER_OPTIONS) {
    return new Intl.NumberFormat(undefined, options).format(value);
}
